// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { grpc } from "../../../app/rpc/executor"
import { narratePreferencesClient } from "../../../app/rpc/client"
import { showSnackBar } from "../../snackbar/actions"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import {
  SetNarratePreferencesRequest,
} from "../../../generated/wisetime/user/assistant/v4/preferences_pb"

type SetNarratePreferencesRpc = (request: SetNarratePreferencesRequest) => Observable<Empty>

export const setNarratePreferences = (setNarratePreferencesRpc: SetNarratePreferencesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.setNarratePreferences.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(setNarratePreferencesRpc),
        mergeMap(() => of(Slice.setSavedNarratePreferences(action.payload.toObject().preferences))),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_set_narrate_preferences_failed",
            message: "Failed to save narrate preferences. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const setNarratePreferencesRpc = (request: SetNarratePreferencesRequest): Observable<Empty> =>
  grpc(() => narratePreferencesClient.setNarratePreferences(request, null))

export default setNarratePreferences(setNarratePreferencesRpc)
